import { APP_NAME_ALREADY_EXIST, MISSING_APP_NAME, MISSING_COMPONENT, } from '../constants/errors';
export var IAvatarOption;
(function (IAvatarOption) {
    IAvatarOption["NONE"] = "none";
    IAvatarOption["INCOMING"] = "incoming";
    IAvatarOption["OUTGOING"] = "outgoing";
    IAvatarOption["BOTH"] = "both";
})(IAvatarOption || (IAvatarOption = {}));
export var TitleOption;
(function (TitleOption) {
    TitleOption["NONE"] = "none";
    TitleOption["INCOMING"] = "incoming";
    TitleOption["OUTGOING"] = "outgoing";
    TitleOption["BOTH"] = "both";
})(TitleOption || (TitleOption = {}));
var AppsRegistry = /** @class */ (function () {
    function AppsRegistry() {
        this._registry = new Map();
    }
    AppsRegistry.prototype.registerApp = function (_a) {
        var appName = _a.appName, component = _a.component, options = _a.options;
        if (!appName) {
            throw MISSING_APP_NAME;
        }
        if (!component) {
            throw MISSING_COMPONENT;
        }
        if (this.isAppRegistered(appName)) {
            throw APP_NAME_ALREADY_EXIST;
        }
        this._registry.set(appName, {
            component: component,
            config: options,
        });
    };
    AppsRegistry.prototype.removeApp = function (appName) {
        this._registry.delete(appName);
    };
    AppsRegistry.prototype.isAppRegistered = function (appName) {
        return this._registry.has(appName);
    };
    AppsRegistry.prototype.getComponentByApp = function (appName) {
        var _a;
        return (_a = this._registry.get(appName)) === null || _a === void 0 ? void 0 : _a.component;
    };
    AppsRegistry.prototype.getConfigByApp = function (appName) {
        var _a;
        return (_a = this._registry.get(appName)) === null || _a === void 0 ? void 0 : _a.config;
    };
    return AppsRegistry;
}());
export default AppsRegistry;
//# sourceMappingURL=apps-registry.js.map